export class NavigationHelper {
    static createTab(url: string, tag: string) {
        return {
            tag: tag,
            url: url
        }
    } 
    static getUrlBack(url: string){
        if (url.startsWith("/")) {
            url = url.substring(1);    
        }        
        let urlArray = url.split("/");
        url = "";
        for (let index = 0; index < 2; index++) {
            url += "/" + urlArray[index];
        }
        return url
    }

    static getUrlBySegment(url: string){
        if (url.startsWith("/")) {
            url = url.substring(1);    
        }        
        let urlArray = url.split("/");
        
        return urlArray
    }
    
    static getUrlComponent(url: string, base?: boolean){
        const listUrl = url.substring(1).split('/');
        return base ? listUrl[0] : listUrl[1];
    }
}